export class LimitStageImpl {
    constructor(count) {
        this.count = count;
    }
    toProto() {
        return { limit: this.count };
    }
}
//# sourceMappingURL=LimitStage.js.map